<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          class="fill"
          d="M29.4717484,14.1316023c7.0916595,3.5082731,9.2376938,11.5134077,8.9764786,18.936306    c-0.2864113,8.1390343-7.5045967,19.6800461-16.8620491,14.39394c-6.9095783-3.9032745-8.9938002-13.0033989-7.5294151-20.4913006    c1.299655-6.6455822,8.0172806-15.6089287,15.6148186-12.6297541c1.348547,0.5287981,1.9332542-1.6460972,0.5981388-2.1696272    c-8.5568295-3.3553362-16.3090363,5.8114452-18.1848946,13.3906307    c-2.2763491,9.1973228,0.5186939,20.4019966,9.6312122,24.5340271c9.0279751,4.0936928,16.3839722-4.1141777,18.4241104-12.249691    c2.298317-9.1650543-0.5894852-21.2330551-9.5327816-25.657341C29.3137856,11.5488529,28.172472,13.4888458,29.4717484,14.1316023    L29.4717484,14.1316023z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M24.6351357,13.139905c0.1987152,12.1666193,0.2379551,24.3336983,0.1177235,36.5013428    c-0.0143108,1.4482422,2.2356777,1.4494057,2.25,0c0.1202316-12.1676483,0.0809917-24.3347263-0.1177235-36.5013428    C26.8615131,11.6935415,24.6114407,11.6891031,24.6351357,13.139905L24.6351357,13.139905z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M35.9188309,19.20508c4.6270599-0.3068295,8.6029243,0.5855618,11.5508232,4.4894962    c0.8617477,1.1412201,2.81633,0.0211945,1.9428101-1.1356182c-3.4469681-4.5648575-7.9704208-5.9701328-13.4936333-5.603878    C34.4815216,17.0503902,34.4708824,19.301096,35.9188309,19.20508L35.9188309,19.20508z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M40.1046982,29.5535812c1.7960052-0.3625565,3.0475235,1.1120377,4.0940971,2.3233795    c0.9466858,1.095726,1.9512138,2.1694336,2.6637306,3.4362755c0.7098694,1.2621346,2.6542053,0.1292343,1.9428062-1.1356201    c-1.0275154-1.8269043-2.5956001-3.6347942-4.1085472-5.0752792c-1.4595566-1.3896523-3.1802368-2.124136-5.1902237-1.7183838    C38.0883179,27.6702499,38.6885986,29.839447,40.1046982,29.5535812L40.1046982,29.5535812z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M38.0355225,41.7645531c1.2423439,0.0014038,2.4846916,0.0028038,3.7270393,0.0042076    c1.6880226,0.0019073,2.1037331,0.5762367,3.0493164,1.8283043c1.0007248,1.3250847,2.0204124,2.3067169,3.5698547,2.9363976    c1.3408012,0.5448914,1.9241905-1.6307297,0.5981407-2.1696281c-2.1302986-0.8657341-2.5262451-3.4136238-4.366478-4.4985008    c-1.6502266-0.9728584-4.7559929-0.3487244-6.5778732-0.3507805    C36.5876846,39.5129166,36.5854301,41.7629166,38.0355225,41.7645531L38.0355225,41.7645531z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M16.15341,17.4479313c-1.6704054-0.2074909-3.795455-0.6821823-5.433074-0.1418266    c-1.6452322,0.5428677-2.9952774,2.4375668-4.1162086,3.6546211c-0.9796653,1.0636749,0.60747,2.6588516,1.5909905,1.5909901    c0.9903851-1.0753136,2.1653767-2.7481976,3.5791779-3.0939617c1.3106346-0.3205338,3.0596437,0.0762787,4.3791142,0.2401772    C17.5868092,19.8759842,17.5738811,17.6243782,16.15341,17.4479313L16.15341,17.4479313z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M11.9806662,28.3552666c-3.0732393,0.4309158-8.2407885,1.794075-9.6072464,4.9815636    c-0.5643399,1.3164139,1.3733516,2.4639702,1.9428091,1.1356163c1.1093264-2.5876865,5.7877111-3.6005383,8.2625761-3.9475517    C14.0067215,30.3246784,13.3991175,28.1563778,11.9806662,28.3552666L11.9806662,28.3552666z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M12.7924175,38.9910774c-1.6233196,0.8226166-3.511137,1.5185699-4.9917421,2.5851555    C6.3003025,42.6570625,5.0602751,44.309761,3.7769217,45.63414c-1.008137,1.0403633,0.5810699,2.633194,1.5909901,1.590992    c1.2233849-1.2624931,2.4350905-2.9206772,3.8873658-3.9163017c1.4002428-0.9599533,3.1572237-1.6069489,4.6727581-2.3749466    C15.219944,40.2792091,14.0823631,38.3373947,12.7924175,38.9910774L12.7924175,38.9910774z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M21.6903419,13.5221634c-0.1797142-2.6357908-0.8941307-5.7801023,2.1830788-6.9569159    c4.323679-1.6534996,7.3252029,1.486598,6.7129784,5.7686043c-0.2024937,1.416275,1.9651756,2.0281029,2.1696281,0.5981398    c0.7327194-5.1247778-1.9965-9.7272043-7.6498394-8.9280739c-2.1792755,0.3080535-3.7456722,0.9984822-5.0251331,2.8373637    c-1.3989735,2.0106478-0.7986794,4.3640423-0.6407127,6.6808815    C19.5383091,14.9589977,21.7890511,14.9698677,21.6903419,13.5221634L21.6903419,13.5221634z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M35.7371025,1.9002957c0.2234764,2.1178107-2.7491035,4.2140694-4.6975937,3.9706693    c-1.433197-0.1790309-1.4201851,2.0725942,0,2.25c3.0892563,0.3859015,7.2914658-2.9619193,6.9475937-6.2206693    C37.8366966,0.4749818,35.5850677,0.4595665,35.7371025,1.9002957L35.7371025,1.9002957z"
        />
      </g>
      <g>
        <path
          class="fill"
          d="M15.2197084,3.0291569c0.6100645,0.1620207,1.083621,1.1765463,1.4503202,1.6568677    c0.3886852,0.5091209,0.7648754,1.0352473,1.1905384,1.5145073c0.8057213,0.9071698,1.7819157,1.5285835,3.019743,1.5545502    c1.4484386,0.030385,1.4482136-2.2196198,0-2.25c-1.1660748-0.0244613-2.0338078-1.6486094-2.6484566-2.4537103    c-0.6814556-0.8926063-1.26721-1.8872771-2.4140062-2.1918426C14.4169664,0.4874843,13.8193235,2.657244,15.2197084,3.0291569    L15.2197084,3.0291569z"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BugIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
